export default "__VITE_ASSET__DmUeLm2r__"